export default {
    getData: function () {
        return {};
    },
    getLegacySeoBlob: function () { },
    getBiData: function () { },
    getSlug: function () { return ''; },
    getKeys: function () { return []; },
    updateItemDataWithSlug: function (item) { return item; },
    getSdKeys: function () { return []; },
};
